import { useState, useEffect } from "react";
import axios from "axios";
import { logout } from "../../store/auth/auth-actions";
import { StyleSheet, css } from "aphrodite";
import { Link } from "react-router-dom";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import LogoutIcon from "@mui/icons-material/LogoutOutlined";
import Divider from "@mui/material/Divider";
// import iconSiga1 from "../../assets/imgs/siga-icos-01.svg";
// import iconSiga2 from "../../assets/imgs/siga-icos-02.svg";
import logoIvitech_colorido from "../../assets/imgs/logoivitech_colorido.png";
import ivitech_reduced from "../../assets/imgs/ivitech_reduced.png";
import "../../assets/styles/drawer.css";
import { headers } from "../core/store/localStorage";
import errorHandler from "../core/store/errorHandler";
import {
  AddBox,
  Event,
  LibraryBooks,
  Payment,
  People,
  Subject,
} from "@mui/icons-material";

// const API_URL = sessionStorage.getItem("apiUrl");
// const userId = sessionStorage.getItem("userId");

const asyncsessionStorage = {
  async getItem(key: any) {
    await null;
    return sessionStorage.getItem(key);
  },
};

interface Props {
  open: boolean;
  openDialog: boolean;
  openQuerySubMenu: boolean;
  toggleDialog: () => void;
  toggleQueryMenu: () => void;
}

const DrawerItemsList: any = (props: Props) => {
  const [pages, setPages] = useState<any>("");
  const [API_URL, setCurrentAPI] = useState<any>("");
  const [userId, setCurrentUserID] = useState<any>("");

  useEffect(() => {
    getAPI();
    getUserID();

    if (
      API_URL === null ||
      userId === null ||
      API_URL === undefined ||
      userId === undefined
    ) {
      window.location.href = "/";
    }
  }, []);

  useEffect(() => {
    getUserAccess();
  }, [API_URL, userId]);

  const { open, openDialog, openQuerySubMenu, toggleDialog, toggleQueryMenu } =
    props;

  const [openCadastrosSubMenu, setOpenCadastrosSubMenu] = useState(false);
  const [openFinanceiroSubMenu, setOpenFinanceiroSubMenu] = useState(false);

  const toggleCadastrosMenu = () => {
    setOpenCadastrosSubMenu(!openCadastrosSubMenu);
  };

  const toggleFinanceiroMenu = () => {
    setOpenFinanceiroSubMenu(!openFinanceiroSubMenu);
  };

  function getAPI() {
    asyncsessionStorage.getItem("apiUrl").then((response) => {
      setCurrentAPI(response);
    });
  }
  function getUserID() {
    asyncsessionStorage.getItem("userId").then((response) => {
      setCurrentUserID(response);
    });
  }

  async function getUserAccess() {
    await axios
      .get(`${API_URL}/user/${userId}/tela`, headers())
      .then((response) => {
        let resp: any = [];
        response.data.data.map((res: any) => {
          resp.push(res.name);
        });
        setPages(resp);
      })
      .catch((err) => {
        errorHandler(err);
      });
  }

  function clearData() {
    sessionStorage.clear();
  }

  return (
    <>
      <div className={css(styles.drawerContainer)}>
        <List style={{ marginTop: "-0.5rem" }}>
          <ListItemButton
            onClick={toggleCadastrosMenu}
            sx={{
              minHeight: 15,
              justifyContent: open ? "initial" : "center",
              px: 2.5,
            }}
            title={open ? "" : "Cadastros"}
          >
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: open ? 1.4 : "auto",
                justifyContent: "center",
              }}
            >
              <AddBox fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary={"Cadastros"}
              sx={{ opacity: open ? 1 : 0 }}
            />
            {openCadastrosSubMenu ? (
              <ExpandLess color="action" fontSize="small" />
            ) : (
              <ExpandMore color="action" fontSize="small" />
            )}
          </ListItemButton>
          {openCadastrosSubMenu && <Divider />}
          <Collapse in={openCadastrosSubMenu} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <Link
                to={"/cadastros/alunos"}
                className={css(styles.noDecoration)}
              >
                <ListItemButton
                  // selected={!!useMatch("/vendas/vendedor/*")}
                  key={"cadAlunos"}
                  sx={{
                    minHeight: 15,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                  title={open ? "" : "Alunos"}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      // marginLeft: open ? 1.5 : "auto",
                      mr: open ? 1.5 : "auto",
                      // ml: open ? "" : -0.2,
                      justifyContent: "center",
                      marginLeft: open ? "6px" : "0",
                    }}
                  >
                    <People fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary={"Alunos"}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>
              </Link>

              <Link
                to={"/cadastros/eventos"}
                className={css(styles.noDecoration)}
              >
                <ListItemButton
                  // selected={!!useMatch("/vendas/vendedor/*")}
                  key={"cadEventos"}
                  sx={{
                    minHeight: 15,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                  title={open ? "" : "Eventos"}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      // marginLeft: open ? 1.5 : "auto",
                      mr: open ? 1.5 : "auto",
                      // ml: open ? "" : -0.2,
                      justifyContent: "center",
                      marginLeft: open ? "6px" : "0",
                    }}
                  >
                    <Event fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary={"Eventos"}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>
              </Link>

              <Link
                to={"/cadastros/turmas"}
                className={css(styles.noDecoration)}
              >
                <ListItemButton
                  // selected={!!useMatch("/vendas/vendedor/*")}
                  key={"cadTurmas"}
                  sx={{
                    minHeight: 15,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                  title={open ? "" : "Turmas"}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      // marginLeft: open ? 1.5 : "auto",
                      mr: open ? 1.5 : "auto",
                      // ml: open ? "" : -0.2,
                      justifyContent: "center",
                      marginLeft: open ? "6px" : "0",
                    }}
                  >
                    <Subject fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary={"Turmas"}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>
              </Link>

              <Link
                to={"/cadastros/disciplinas"}
                className={css(styles.noDecoration)}
              >
                <ListItemButton
                  // selected={!!useMatch("/vendas/vendedor/*")}
                  key={"cadDisciplinas"}
                  sx={{
                    minHeight: 15,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                  title={open ? "" : "Disciplinas"}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      // marginLeft: open ? 1.5 : "auto",
                      mr: open ? 1.5 : "auto",
                      // ml: open ? "" : -0.2,
                      justifyContent: "center",
                      marginLeft: open ? "6px" : "0",
                    }}
                  >
                    <LibraryBooks fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary={"Disciplinas"}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>
              </Link>
            </List>
          </Collapse>

          <ListItemButton
            onClick={toggleFinanceiroMenu}
            sx={{
              minHeight: 15,
              justifyContent: open ? "initial" : "center",
              px: 2.5,
            }}
            title={open ? "" : "Financeiro"}
          >
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: open ? 1.4 : "auto",
                justifyContent: "center",
              }}
            >
              <Payment fontSize="small" />
            </ListItemIcon>
            <ListItemText
              primary={"Financeiro"}
              sx={{ opacity: open ? 1 : 0 }}
            />
            {openFinanceiroSubMenu ? (
              <ExpandLess color="action" fontSize="small" />
            ) : (
              <ExpandMore color="action" fontSize="small" />
            )}
          </ListItemButton>
          {openFinanceiroSubMenu && <Divider />}
          <Collapse in={openFinanceiroSubMenu} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <Link
                to={"/financeiro/alunos"}
                className={css(styles.noDecoration)}
              >
                <ListItemButton
                  // selected={!!useMatch("/vendas/vendedor/*")}
                  key={"consultarAlunos"}
                  sx={{
                    minHeight: 15,
                    justifyContent: open ? "initial" : "center",
                    px: 2.5,
                  }}
                  title={open ? "" : "Consultar Alunos"}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 0,
                      // marginLeft: open ? 1.5 : "auto",
                      mr: open ? 1.5 : "auto",
                      // ml: open ? "" : -0.2,
                      justifyContent: "center",
                      marginLeft: open ? "6px" : "0",
                    }}
                  >
                    <People fontSize="small" />
                  </ListItemIcon>
                  <ListItemText
                    primary={"Consultar Alunos"}
                    sx={{ opacity: open ? 1 : 0 }}
                  />
                </ListItemButton>
              </Link>
            </List>
          </Collapse>

          <Divider />
          {/* <Link to={"/"} className={css(styles.noDecoration)}> */}
          <ListItemButton
            key={"Sair"}
            sx={{
              minHeight: 15,
              justifyContent: open ? "initial" : "center",
              px: 2.5,
            }}
            title={open ? "" : "Sair"}
            onClick={toggleDialog}
          >
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: open ? 1.4 : "auto",
                ml: open ? 0.2 : "",
                justifyContent: "center",
              }}
            >
              <LogoutIcon />
            </ListItemIcon>
            <ListItemText primary={"Sair"} sx={{ opacity: open ? 1 : 0 }} />
          </ListItemButton>
          {/* </Link> */}
        </List>
        <div className={css(styles.logoContainer)}>
          <Link to={"https://ivitech.com.br"} target="_blank">
            <img
              src={open ? logoIvitech_colorido : ivitech_reduced}
              style={{
                width: open ? "6.5rem" : "2.5rem",
              }}
            />
          </Link>
        </div>
      </div>
    </>
  );
};

const styles = StyleSheet.create({
  noDecoration: {
    textDecoration: "none",
    color: "inherit",
  },
  drawerContainer: {
    height: "100vh",
    transition: "width 0.3s ease",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    overflowY: "auto",
    overflowX: "hidden",
    "::-webkit-scrollbar": {
      width: "8px",
    },
    "::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "4px",
    },
    "::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
  },
  logoContainer: {
    padding: "12px",
    textAlign: "center",
    marginTop: "auto", // Ainda mantém no final, mas sem position fixed
  },
});

export default DrawerItemsList;
